const Source = () => {
    return (
        <>
            <p className="source">
                Note: Intermarriage refers to marriages between a Hispanic and a
                non-Hispanic, or marriages between non-Hispanic spouses who come
                from the following different racial groups: white, black, Asian,
                American Indian, multiracial or some other race. Figures shown
                are based on combined data from 2011 to 2015, among people who
                were married in the 12 months prior to being surveyed. Values
                are shown for metro areas, races and ethnicities with sample
                sizes of at least 200. A dash (-) indicates that sample size is
                too small to analyze (fewer than 200 cases). Whites, blacks and
                Asians include only non-Hispanics. Hispanics are of any race.
                Asians include Pacific Islanders. Totals for the U.S. include
                all areas of the United States, including non-metro areas. Total
                % intermarried includes all races, including those not
                displayed.
            </p>
            <p className="source">
                Source: Pew Research Center analysis of 2011-2015 American
                Community Survey (IPUMS).
            </p>
        </>
    );
};

export default Source;
